import { AppBar, Box, ButtonBase, Stack, Typography } from '@mui/material';
import Container from '@mui/material/Container';
import styled from '@mui/material/styles/styled';
import FlexBetween from '../../components/flexbox/FlexBetween';
import { useTonAddress, useTonConnectModal, useTonConnectUI, useTonWallet } from '@tonconnect/ui-react';
import { shortenAddress } from '../../utils/until';
import TelegramLoginButton from '../../page-sections/TelegramLoginButton';
import useSocket from '../../hooks/useSocket';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import toast from 'react-hot-toast';

const StyledRoot = styled('div')(() => ({

}));
export default function HeaderEffect({
  children
}) {


  const wallet = useTonWallet();
  const { open: openConnectWallet } = useTonConnectModal()
  const walletAddress = useTonAddress(true);
  const [tonConnectUi] = useTonConnectUI();

  const botName = 'test_login_aaa_bot'

  return <AppBar position='relative' sx={{ px: { xs: 1, md: 5 }, py: { xs: 0, md: 1 }, background: 'none', boxShadow: 0, zIndex: 1 }}>
    <FlexBetween py={2}>
      <Box height={{ xs: 100, md: 60 }}>
        <img src='/images/logo/logo.png' height={'100%'} />
      </Box>
      <Box flexGrow={1} />

      <Stack spacing={1} direction={{ xs: 'column', md: 'row' }}>
        <TelegramLoginButton
          botName={process.env.REACT_APP_IS_DEV == 'true'? 'test_login_aaa_bot' : 'furydefender_bot'}
        />
        <ButtonBase onClick={() => {
          if (!wallet) {
            openConnectWallet()
          } else {
            tonConnectUi.disconnect()
          }
        }} sx={{ height: 45, width: 165, background: 'url("/images/button-2.png") no-repeat 50% 50%', backgroundSize: 'contain' }}>
          <Typography fontSize={'0.9rem'}>{!wallet ? "CONNECT WALLET" : shortenAddress(walletAddress)}</Typography>
        </ButtonBase>
      </Stack>
    </FlexBetween>
  </AppBar >;
}